import {
  useBrokerageFirmControllerUpdateBrokerageFirm,
  useInvitationControllerBrokerInvite,
} from 'korint-sdk';

import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { FormBuilder } from '../../components/forms/form-builder/FormBuilder';
import { buildPayloadFromFields } from '../../components/forms/form-builder/form-fields-builders';
import { getResolver } from '../../components/forms/form-builder/getZodResolverFromFields';
import { StepperFooter } from '../../components/navigation/stepper-footer';
import { useStepperContext } from '../../components/layout/StepperLayout/useStepperContext';
import { type Field } from 'korint-sdk/react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Stack } from '@folio/components/ui/flex';

type RetailInviteModuleProps = {
  showPreviousButton?: boolean;
};

export function RetailInviteModule({ showPreviousButton = true }: RetailInviteModuleProps) {
  const { t } = useTranslation();
  const stepper = useStepperContext();

  const fields = [
    {
      name: 'contactEmail',
      required: true,
      type: 'email',
      DEPRECATED_placeholder: 'michel.dupont@gmail.com',
      isCustomField: true,
    },
    {
      name: 'contactFirstName',
      required: true,
      type: 'text',
      DEPRECATED_placeholder: 'Michel',
      isCustomField: true,
    },
    {
      name: 'contactLastName',
      required: true,
      type: 'text',
      DEPRECATED_placeholder: 'Dupont',
      isCustomField: true,
    },
  ] as const satisfies Field[];

  const { brokerageFirmId } = useParams();
  if (!brokerageFirmId) {
    throw new Error('Brokerage firm ID is required');
  }
  const form = useForm({
    resolver: getResolver(fields),
  });

  const { mutateAsync: updateBrokerageFirm } = useBrokerageFirmControllerUpdateBrokerageFirm();

  const { mutateAsync: createBrokerInvite } = useInvitationControllerBrokerInvite();

  return (
    <Stack>
      <Card>
        <CardHeader>
          <CardTitle>{t('retailInvite.title')}</CardTitle>
        </CardHeader>
        <CardContent>
          <FormBuilder fields={fields} form={form} />
        </CardContent>
      </Card>
      <StepperFooter
        onNext={form.handleSubmit(async data => {
          await updateBrokerageFirm({
            brokerageFirmId,
            data: buildPayloadFromFields(fields, data),
          });

          await createBrokerInvite({
            data: {
              email: data.contactEmail,
              firstName: data.contactFirstName,
              lastName: data.contactLastName,
              brokerRole: 'RETAIL_ADMIN',
              brokerageFirmId: brokerageFirmId,
            },
          });

          stepper.next();
        })}
        nextButtonEnabled={true}
        showPreviousButton={showPreviousButton}
      />
    </Stack>
  );
}
